<template>
  <div class="download-template-page">
    <div class="container">
      <h1 class="page-title">Download Templates</h1>
      <p class="page-description">Get started with our pre-designed templates for invoices and report headers.</p>

      <div class="template-cards">
        <!-- Invoice Template Card -->
        <div class="template-card">
          <div class="template-icon">
            <i class="fas fa-file-invoice-dollar"></i>
          </div>
          <h3 class="template-title">Invoice Template</h3>
          <p class="template-description">Professional invoice template with all necessary fields.</p>
          <div class="download-options">
            <button @click="downloadTemplate('invoice', 'pdf')" class="download-btn">
              <i class="fas fa-file-pdf"></i> PDF
            </button>
            <button @click="downloadTemplate('invoice', 'docx')" class="download-btn">
              <i class="fas fa-file-word"></i> Word
            </button>
            <button @click="downloadTemplate('invoice', 'xlsx')" class="downl oad-btn">
              <i class="fas fa-file-excel"></i> Excel
            </button>
          </div>
        </div>

        <!-- Report Header Template Card -->
        <div class="template-card">
          <div class="template-icon">
            <i class="fas fa-file-alt"></i>
          </div>
          <h3 class="template-title">Report Header Template</h3>
          <p class="template-description">Standardized report header for all your business documents.</p>
          <div class="download-options">
            <button @click="downloadTemplate('report-header', 'pdf')" class="download-btn">
              <i class="fas fa-file-pdf"></i> PDF
            </button>
            <button @click="downloadTemplate('report-header', 'docx')" class="download-btn">
              <i class="fas fa-file-word"></i> Word
            </button>
            <button @click="downloadTemplate('report-header', 'xlsx')" class="download-btn">
              <i class="fas fa-file-excel"></i> Excel
            </button>
          </div>
        </div>
      </div>

      <div class="instructions">
        <h3>How to Use These Templates</h3>
        <ol>
          <li>Download the template in your preferred format</li>
          <li>Open the file in the appropriate application</li>
          <li>Fill in your specific information</li>
          <li>Save and use as needed</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadTemplatePage',
  methods: {
    downloadTemplate(templateType, fileFormat) {
      // In a real application, this would trigger a file download
      // For now, we'll just log the action
      console.log(`Downloading ${templateType} in ${fileFormat} format`);
      
      // Example of how you might implement the actual download:
      // const fileName = `${templateType}-template.${fileFormat}`;
      // const fileUrl = `/templates/${fileName}`;
      // const link = document.createElement('a');
      // link.href = fileUrl;
      // link.download = fileName;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      
      // Show success message
      this.$toast.success(`Downloading ${templateType} template (${fileFormat})`);
    }
  }
}
</script>

<style scoped>
.download-template-page {
  padding: 2rem 0;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.page-description {
  text-align: center;
  color: #7f8c8d;
  max-width: 700px;
  margin: 0 auto 2rem;
}

.template-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.template-card {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.template-card:hover {
  transform: translateY(-5px);
}

.template-icon {
  font-size: 2.5rem;
  color: #3498db;
  margin-bottom: 1rem;
  text-align: center;
}

.template-title {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  text-align: center;
}

.template-description {
  color: #7f8c8d;
  margin-bottom: 1.5rem;
  text-align: center;
}

.download-options {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.download-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  background-color: #3498db;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.download-btn:hover {
  background-color: #2980b9;
}

.download-btn i {
  font-size: 1.2rem;
}

.instructions {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  margin: 0 auto;
}

.instructions h3 {
  color: #2c3e50;
  margin-bottom: 1rem;
}

.instructions ol {
  padding-left: 1.5rem;
  color: #7f8c8d;
}

.instructions li {
  margin-bottom: 0.5rem;
}
</style>


/*
<!-- 

<template>
  <div class="download-template-page">
    <div class="container">
      <h1 class="page-title">Download Templates</h1>
      <p class="page-description">Get started with our pre-designed templates for invoices and report headers.</p>

      <div class="template-cards">
     
        <div class="template-card">
          <div class="template-icon">
            <v-icon large color="primary">mdi-file-document</v-icon>
          </div>
          <h3 class="template-title">Report Header Template</h3>
          <p class="template-description">Standardized report header for all business documents.</p>
          <div class="download-options">
            <v-btn color="primary" @click="downloadReportHeader('pdf')" :loading="isLoading.pdf">
              <v-icon left>mdi-file-pdf-box</v-icon> PDF
            </v-btn>
            <v-btn color="primary" @click="downloadReportHeader('docx')" :loading="isLoading.docx" class="ml-2">
              <v-icon left>mdi-file-word</v-icon> Word
            </v-btn>
            <v-btn color="primary" @click="downloadReportHeader('xlsx')" :loading="isLoading.xlsx" class="ml-2">
              <v-icon left>mdi-file-excel</v-icon> Excel
            </v-btn>
          </div>
        </div>
      </div>

      <div class="instructions">
        <h3>How to Use These Templates</h3>
        <ol>
          <li>Download the template in your preferred format</li>
          <li>Open the file in the appropriate application</li>
          <li>Fill in your specific information</li>
          <li>Save and use as needed</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { saveAs } from 'file-saver';
import { Document, Paragraph, TextRun, Packer, AlignmentType } from 'docx';
import ExcelJS from 'exceljs';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: 'DownloadTemplatePage',
  data() {
    return {
      isLoading: {
        pdf: false,
        docx: false,
        xlsx: false
      },
      companyInfo: {
        name: "GQ Property Group",
        address: "33 Donkin Street Central Port Elizabeth Eastern Cape",
        phone: "0615175157",
        email: "rent@gqproperty.co.za",
        website: "www.gqproperty.co.za"
      },
      currentDate: new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    };
  },
  methods: {
    async downloadReportHeader(format) {
      this.isLoading[format] = true;
      
      try {
        if (format === 'pdf') {
          await this.downloadPDFReportHeader();
        } else if (format === 'docx') {
          await this.downloadWordReportHeader();
        } else if (format === 'xlsx') {
          await this.downloadExcelReportHeader();
        }
        
        this.$toast.success(`Report header template downloaded (${format})`);
      } catch (error) {
        console.error("Error downloading template:", error);
        this.$toast.error("Failed to download template");
      } finally {
        this.isLoading[format] = false;
      }
    },
    
    // PDF Template
    async downloadPDFReportHeader() {
      const docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins: [40, 60, 40, 80],
        defaultStyle: {
          font: 'Roboto',
          fontSize: 10
        },
        header: {
          columns: [
            {
              stack: [
                {
                  text: 'GQ PROPERTY GROUP',
                  style: 'companyHeader',
                  margin: [0, 20, 0, 0]
                },
                {
                  text: 'Professional Property Management',
                  style: 'companySubheader',
                  margin: [0, 5, 0, 10]
                }
              ],
              width: '*'
            },
            {
              image: 'logo', // You would add your logo here
              width: 80,
              alignment: 'right'
            }
          ],
          margin: [40, 20, 40, 0]
        },
        content: [
          {
            text: 'OFFICIAL REPORT',
            style: 'reportTitle',
            margin: [0, 20, 0, 10]
          },
          {
            text: 'This document contains confidential information for authorized use only',
            style: 'reportSubtitle',
            margin: [0, 0, 0, 20]
          },
          {
            table: {
              widths: ['*', '*'],
              body: [
                [
                  { text: 'Property:', style: 'label' },
                  { text: '[Property Name]', style: 'value' }
                ],
                [
                  { text: 'Report Period:', style: 'label' },
                  { text: '[Start Date] to [End Date]', style: 'value' }
                ],
                [
                  { text: 'Prepared By:', style: 'label' },
                  { text: '[Your Name]', style: 'value' }
                ],
                [
                  { text: 'Date Generated:', style: 'label' },
                  { text: this.currentDate, style: 'value' }
                ]
              ]
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 30]
          }
        ],
        footer: (currentPage, pageCount) => ({
          stack: [
            {
              canvas: [{ 
                type: 'line',
                x1: 0, y1: 0,
                x2: 515, y2: 0,
                lineWidth: 1,
                lineColor: '#000000'
              }],
              margin: [0, 0, 0, 10]
            },
            {
              columns: [
                {
                  text: [
                    { text: `${this.companyInfo.name}\n`, bold: true },
                    { text: `${this.companyInfo.address}\n` },
                    { text: `Tel: ${this.companyInfo.phone} | Email: ${this.companyInfo.email}\n` },
                    { text: `Website: ${this.companyInfo.website}` }
                  ],
                  width: '70%',
                  style: 'footerText'
                },
                {
                  text: `Page ${currentPage} of ${pageCount}`,
                  width: '30%',
                  alignment: 'right',
                  style: 'pageNumber'
                }
              ],
              margin: [0, 5, 0, 0]
            }
          ],
          margin: [40, 10, 40, 20]
        }),
        styles: {
          companyHeader: {
            fontSize: 18,
            bold: true,
            color: '#000080',
            alignment: 'left'
          },
          companySubheader: {
            fontSize: 12,
            color: '#666666',
            alignment: 'left'
          },
          reportTitle: {
            fontSize: 16,
            bold: true,
            color: '#000000',
            alignment: 'center'
          },
          reportSubtitle: {
            fontSize: 12,
            color: '#666666',
            alignment: 'center'
          },
          label: {
            fontSize: 10,
            bold: true,
            margin: [0, 5, 0, 5]
          },
          value: {
            fontSize: 10,
            margin: [0, 5, 0, 5]
          },
          footerText: {
            fontSize: 9,
            lineHeight: 1.3
          },
          pageNumber: {
            fontSize: 9
          }
        }
      };
      
      pdfMake.createPdf(docDefinition).download('GQ_Property_Report_Template.pdf');
    },
    
    // Word Template
    async downloadWordReportHeader() {
      const doc = new Document({
        styles: {
          paragraphStyles: [
            {
              id: "CompanyHeader",
              name: "Company Header",
              run: {
                size: 36,
                bold: true,
                color: "000080"
              },
              paragraph: {
                spacing: { after: 100 },
                alignment: AlignmentType.LEFT
              }
            },
            {
              id: "CompanySubheader",
              name: "Company Subheader",
              run: {
                size: 24,
                color: "666666"
              },
              paragraph: {
                spacing: { after: 200 },
                alignment: AlignmentType.LEFT
              }
            },
            {
              id: "ReportTitle",
              name: "Report Title",
              run: {
                size: 32,
                bold: true
              },
              paragraph: {
                spacing: { after: 200 },
                alignment: AlignmentType.CENTER
              }
            },
            {
              id: "ReportSubtitle",
              name: "Report Subtitle",
              run: {
                size: 24,
                color: "666666"
              },
              paragraph: {
                spacing: { after: 200 },
                alignment: AlignmentType.CENTER
              }
            },
            {
              id: "Label",
              name: "Label",
              run: {
                size: 20,
                bold: true
              },
              paragraph: {
                spacing: { after: 100 }
              }
            },
            {
              id: "Value",
              name: "Value",
              run: {
                size: 20
              },
              paragraph: {
                spacing: { after: 100 }
              }
            },
            {
              id: "FooterText",
              name: "Footer Text",
              run: {
                size: 18
              },
              paragraph: {
                spacing: { line: 300 }
              }
            },
            {
              id: "PageNumber",
              name: "Page Number",
              run: {
                size: 18
              },
              paragraph: {
                alignment: AlignmentType.RIGHT
              }
            }
          ]
        },
        sections: [{
          properties: {
            page: {
              margin: {
                top: 1000,
                right: 1000,
                bottom: 1000,
                left: 1000
              }
            }
          },
          headers: {
            default: new Paragraph({
              children: [
                new TextRun({
                  text: "GQ PROPERTY GROUP",
                  style: "CompanyHeader"
                }),
                new TextRun({
                  text: "\nProfessional Property Management",
                  style: "CompanySubheader"
                })
              ]
            })
          },
          children: [
            new Paragraph({
              text: "OFFICIAL REPORT",
              style: "ReportTitle"
            }),
            new Paragraph({
              text: "This document contains confidential information for authorized use only",
              style: "ReportSubtitle"
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Property: ",
                  style: "Label"
                }),
                new TextRun({
                  text: "[Property Name]",
                  style: "Value"
                })
              ]
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Report Period: ",
                  style: "Label"
                }),
                new TextRun({
                  text: "[Start Date] to [End Date]",
                  style: "Value"
                })
              ]
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Prepared By: ",
                  style: "Label"
                }),
                new TextRun({
                  text: "[Your Name]",
                  style: "Value"
                })
              ]
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Date Generated: ",
                  style: "Label"
                }),
                new TextRun({
                  text: this.currentDate,
                  style: "Value"
                })
              ]
            }),
            new Paragraph({
              text: " "
            })
          ],
          footers: {
            default: new Paragraph({
              children: [
                new TextRun({
                  text: `${this.companyInfo.name}\n${this.companyInfo.address}\nTel: ${this.companyInfo.phone} | Email: ${this.companyInfo.email}\nWebsite: ${this.companyInfo.website}`,
                  style: "FooterText"
                }),
                new TextRun({
                  text: "\t\tPage 1 of 1", // Page numbers would be dynamic in a real implementation
                  style: "PageNumber"
                })
              ]
            })
          }
        }]
      });
      
      const blob = await Packer.toBlob(doc);
      saveAs(blob, 'GQ_Property_Report_Template.docx');
    },
    
    // Excel Template
    async downloadExcelReportHeader() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Report Header');
      
      // Set company styles
      const companyHeaderStyle = {
        font: { bold: true, size: 18, color: { argb: 'FF000080' } },
        alignment: { horizontal: 'left' }
      };
      
      const companySubheaderStyle = {
        font: { size: 14, color: { argb: 'FF666666' } },
        alignment: { horizontal: 'left' }
      };
      
      const reportTitleStyle = {
        font: { bold: true, size: 16 },
        alignment: { horizontal: 'center' }
      };
      
      const reportSubtitleStyle = {
        font: { size: 12, color: { argb: 'FF666666' } },
        alignment: { horizontal: 'center' }
      };
      
      const labelStyle = {
        font: { bold: true, size: 11 }
      };
      
      const valueStyle = {
        font: { size: 11 }
      };
      
      const footerStyle = {
        font: { size: 10 },
        alignment: { horizontal: 'left', wrapText: true }
      };
      
      // Add content
      worksheet.mergeCells('A1:B1');
      worksheet.getCell('A1').value = 'GQ PROPERTY GROUP';
      worksheet.getCell('A1').style = companyHeaderStyle;
      
      worksheet.mergeCells('A2:B2');
      worksheet.getCell('A2').value = 'Professional Property Management';
      worksheet.getCell('A2').style = companySubheaderStyle;
      
      worksheet.mergeCells('A4:B4');
      worksheet.getCell('A4').value = 'OFFICIAL REPORT';
      worksheet.getCell('A4').style = reportTitleStyle;
      
      worksheet.mergeCells('A5:B5');
      worksheet.getCell('A5').value = 'This document contains confidential information for authorized use only';
      worksheet.getCell('A5').style = reportSubtitleStyle;
      
      // Property Info
      worksheet.getCell('A7').value = 'Property:';
      worksheet.getCell('A7').style = labelStyle;
      worksheet.getCell('B7').value = '[Property Name]';
      worksheet.getCell('B7').style = valueStyle;
      
      worksheet.getCell('A8').value = 'Report Period:';
      worksheet.getCell('A8').style = labelStyle;
      worksheet.getCell('B8').value = '[Start Date] to [End Date]';
      worksheet.getCell('B8').style = valueStyle;
      
      worksheet.getCell('A9').value = 'Prepared By:';
      worksheet.getCell('A9').style = labelStyle;
      worksheet.getCell('B9').value = '[Your Name]';
      worksheet.getCell('B9').style = valueStyle;
      
      worksheet.getCell('A10').value = 'Date Generated:';
      worksheet.getCell('A10').style = labelStyle;
      worksheet.getCell('B10').value = this.currentDate;
      worksheet.getCell('B10').style = valueStyle;
      
      // Footer
      worksheet.mergeCells('A12:B12');
      worksheet.getCell('A12').value = `${this.companyInfo.name}`;
      worksheet.getCell('A12').style = { ...footerStyle, font: { ...footerStyle.font, bold: true } };
      
      worksheet.mergeCells('A13:B13');
      worksheet.getCell('A13').value = this.companyInfo.address;
      worksheet.getCell('A13').style = footerStyle;
      
      worksheet.mergeCells('A14:B14');
      worksheet.getCell('A14').value = `Tel: ${this.companyInfo.phone} | Email: ${this.companyInfo.email}`;
      worksheet.getCell('A14').style = footerStyle;
      
      worksheet.mergeCells('A15:B15');
      worksheet.getCell('A15').value = `Website: ${this.companyInfo.website}`;
      worksheet.getCell('A15').style = footerStyle;
      
      // Set column widths
      worksheet.columns = [
        { width: 25 },
        { width: 40 }
      ];
      
      // Add border to footer
      for (let i = 12; i <= 15; i++) {
        worksheet.getCell(`A${i}`).border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' }
        };
        worksheet.getCell(`B${i}`).border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' }
        };
      }
      
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), 'GQ_Property_Report_Template.xlsx');
    }
  }
};
</script>

<style scoped>
.download-template-page {
  padding: 2rem 0;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.page-description {
  text-align: center;
  color: #7f8c8d;
  max-width: 700px;
  margin: 0 auto 2rem;
}

.template-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.template-card {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.template-card:hover {
  transform: translateY(-5px);
}

.template-icon {
  text-align: center;
  margin-bottom: 1rem;
}

.template-title {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  text-align: center;
}

.template-description {
  color: #7f8c8d;
  margin-bottom: 1.5rem;
  text-align: center;
}

.download-options {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.instructions {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  margin: 0 auto;
}

.instructions h3 {
  color: #2c3e50;
  margin-bottom: 1rem;
}

.instructions ol {
  padding-left: 1.5rem;
  color: #7f8c8d;
}

.instructions li {
  margin-bottom: 0.5rem;
}
</style>


*/ -->